import { gql } from '@apollo/client';

export const REDEEM_CODE_REWARD_FRAGMENT = gql`
  fragment RedeemCodeRewardFragment on LevelReward {
    __typename
    ... on Currency {
      amount
    }
    ... on CurrencyBoost {
      amount
      boostType
    }
    ... on CurrencyUnlimitedBoost {
      amount
      unlimitedBoostType
    }
    ... on CurrencyCategoryFragment {
      amount
      category {
        id
      }
    }
    ... on CurrencyCategoryRandom {
      amount
    }
    ... on ContentPackReward {
      contentPack {
        id
      }
    }
    ... on AppSkin {
      id
    }
    ... on Sticker {
      id
    }
    ... on ProfileFrame {
      id
    }
    ... on Badge {
      id
      name
    }
    ... on Poster {
      id
    }
    ... on Emoji {
      id
    }
    ... on EmojiPack {
      id
    }
  }
`;

export const REDEEM_CODE_FRAGMENT = gql`
  fragment RedeemCodeFragment on RedeemCode {
    id
    code
    enabledIos
    enabledAndroid
    successMessage
    startDate
    endDate
    filterUserIds
    filterAppVersion
    filterAppVersionOperator
    filterSubscriptionTier
    filterUserLevel
    filterUserMinCreationDate
    filterUserMaxCreationDate
    created
    updatedAt
    rewards {
      ...RedeemCodeRewardFragment
    }
  }
  ${REDEEM_CODE_REWARD_FRAGMENT}
`;

export const LIVEOPS_REDEEM_CODES_QUERY = gql`
  query getLiveOpsRedeemCodes {
    liveOps {
      id
      redeemCodes {
        ...RedeemCodeFragment
      }
    }
  }
  ${REDEEM_CODE_FRAGMENT}
`;

export const CREATE_REDEEM_CODE = gql`
  mutation createRedeemCode(
    $code: String!
    $enabledIos: Boolean
    $enabledAndroid: Boolean
    $successMessage: String
    $startDate: Date!
    $endDate: Date
    $filterUserIds: [ID!]
    $filterAppVersion: String
    $filterAppVersionOperator: String
    $filterSubscriptionTier: UserSubscriptionTier
    $filterUserLevel: Int
    $filterUserMinCreationDate: Date
    $filterUserMaxCreationDate: Date
    $rewards: [LevelRewardInput!]!
  ) {
    createRedeemCode(
      code: $code
      enabledIos: $enabledIos
      enabledAndroid: $enabledAndroid
      successMessage: $successMessage
      startDate: $startDate
      endDate: $endDate
      filterUserIds: $filterUserIds
      filterAppVersion: $filterAppVersion
      filterAppVersionOperator: $filterAppVersionOperator
      filterSubscriptionTier: $filterSubscriptionTier
      filterUserLevel: $filterUserLevel
      filterUserMinCreationDate: $filterUserMinCreationDate
      filterUserMaxCreationDate: $filterUserMaxCreationDate
      rewards: $rewards
    ) {
      ...RedeemCodeFragment
    }
  }
  ${REDEEM_CODE_FRAGMENT}
`;

export const UPDATE_REDEEM_CODE = gql`
  mutation updateRedeemCode(
    $id: ID!
    $code: String
    $enabledIos: Boolean
    $enabledAndroid: Boolean
    $successMessage: String
    $startDate: Date
    $endDate: Date
    $filterUserIds: [ID!]
    $filterAppVersion: String
    $filterAppVersionOperator: String
    $filterSubscriptionTier: UserSubscriptionTier
    $filterUserLevel: Int
    $filterUserMinCreationDate: Date
    $filterUserMaxCreationDate: Date
    $rewards: [LevelRewardInput!]
  ) {
    updateRedeemCode(
      id: $id
      code: $code
      enabledIos: $enabledIos
      enabledAndroid: $enabledAndroid
      successMessage: $successMessage
      startDate: $startDate
      endDate: $endDate
      filterUserIds: $filterUserIds
      filterAppVersion: $filterAppVersion
      filterAppVersionOperator: $filterAppVersionOperator
      filterSubscriptionTier: $filterSubscriptionTier
      filterUserLevel: $filterUserLevel
      filterUserMinCreationDate: $filterUserMinCreationDate
      filterUserMaxCreationDate: $filterUserMaxCreationDate
      rewards: $rewards
    ) {
      ...RedeemCodeFragment
    }
  }
  ${REDEEM_CODE_FRAGMENT}
`;

export const DELETE_REDEEM_CODE = gql`
  mutation deleteRedeemCode($id: ID!) {
    deleteRedeemCode(id: $id)
  }
`;

export const REDEEM_CODE_FEATURE_CONFIG_QUERY = gql`
  query getRedeemCodeFeatureConfig {
    liveOps {
      id
      redeemCodeFeatureConfig {
        ios
        android
      }
    }
  }
`;

export const UPDATE_REDEEM_CODE_FEATURE_CONFIG = gql`
  mutation updateRedeemCodeFeatureConfig($input: RedeemCodeFeatureConfigInput!) {
    updateRedeemCodeFeatureConfig(input: $input) {
      ios
      android
    }
  }
`;
